import { Typography } from "@mui/material";
import { EditableTextField } from "datasheets/components/EditableTextField";
import { workbookNameAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";
import { useAtom } from "jotai";

export function WorkbookName() {
  const [workbookName, setWorkbookName] = useAtom(workbookNameAtom);
  return (
    <EditableTextField
      displayText={workbookName}
      setDisplayText={setWorkbookName}
    >
      <Typography variant="h6">{workbookName}</Typography>
    </EditableTextField>
  );
}
